import { render } from "./WorkAreaDeleteButton.vue?vue&type=template&id=5f22a778"
import script from "./WorkAreaDeleteButton.vue?vue&type=script&lang=ts"
export * from "./WorkAreaDeleteButton.vue?vue&type=script&lang=ts"
script.render = render

export default script